import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { toDropDownOptions } from 'utils/dropdownOptions';
import platformOptions from 'constants/platformOptions';
import featureTypeOptions from 'constants/featureTypeOptions';
import featureStatusOptions from 'constants/featureStatusOptions';
import featureFrequencyOptions from 'constants/featureFrequencyOptions';

const SettingFeaturesFilter = ({ form, handleChange }) => (
  <>
    <Form.Select
      name="platform"
      label="Platform"
      placeholder="Platform Name"
      clearable
      search
      fluid
      value={form.platform}
      options={toDropDownOptions(platformOptions)}
      onChange={handleChange}
    />
    <Form.Select
      name="active_frequency"
      label="Frequency"
      placeholder="Frequency"
      clearable
      search
      fluid
      value={form.active_frequency}
      options={toDropDownOptions(featureFrequencyOptions)}
      onChange={handleChange}
    />
    <Form.Select
      name="feature_name"
      label="Accessibility level"
      placeholder="Type"
      clearable
      search
      fluid
      value={form.feature_name}
      options={toDropDownOptions(featureTypeOptions)}
      onChange={handleChange}
    />
    <Form.Select
      name="status"
      label="Status"
      placeholder="Status"
      clearable
      search
      fluid
      value={form.status}
      options={toDropDownOptions(featureStatusOptions)}
      onChange={handleChange}
    />
  </>
);

SettingFeaturesFilter.propTypes = {
  form: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default SettingFeaturesFilter;
